import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { fnLogout } from "utils/logout";

const Page403 = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    alert('권한이 없습니다. 다시 로그인해주세요.');
    fnLogout(dispatch, history);
  }, [])

  return (
    <div></div>
  )
}

export default Page403;